<template>
  <div class="bg" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="bgbody">
      <div class="center">
        <div class="header">恭喜您，签到成功！</div>
        <div class="registerCon">
          <div class="radius">
            <img src="../assets/gou.png" alt="" />
            <div class="registerOk">签到成功</div>
          </div>
        </div>
        <div class="complete">
          <div class="comButton" @click="comHandle">
            <div class="comText">完成</div>
          </div>
        </div>
        <div class="registerBottomContainer">
          <div class="registerBottom">
            <div class="leftButton">已签到</div>
            <div class="bottomList">
              <ul :style="{ width: participants.length * 233 + 'px' }">
                <li v-for="(i, index) in participants" :key="index">
                  <div class="AstarLi">
                    <div class="astarText">{{ i.attendeeName }}</div>
                    <div class="astarText">{{ i.signTime }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="registerBottom">
            <div class="leftButton1">未签到</div>
            <div class="bottomList">
              <ul :style="{ width: unregisterlist.length * 162 + 'px' }">
                <li v-for="(i, index) in unregisterlist" :key="index">
                  <div class="AstarLi">
                    <div class="astarText">{{ i.attendeeName }}</div>
                    <div class="astarText">{{ i.attendeeTel }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import { personLists, getMeetModel } from "@/utils/request";
export default {
  name: "register",
  components: {
    HomeHeader
  },
  data() {
    return {
      //   timeArea: '11:00-13:00',
      //   meetingTite: 'XXX项目进度页面',
      //   meetingStarttime: '2020-9-14 11:00:00',
      //   meetingEndtime: '2020-9-14 13:00:00',
      //   timeTip: '',
      participants: [],
      unregisterlist: [],
      fonts: "",
      timeClock: null,
      bgUrl:''
    };
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.bgUrl = localStorage.getItem('bgUrl')
    this.personLists();
    // this.timeClock = setInterval(() => {
    //   this.getMeetModels();
    // }, 2000);
    setTimeout(() => {
      this.comHandle();
    }, 10000);
  },
  beforeDestroy() {
    // if (this.timeClock) {
    //   clearInterval(this.timeClock);
    // }
  },
  methods: {
    // getMeetModels() {
    //   getMeetModel().then(res => {
    //     if (Number(res.code) === 0) {
    //       this.fonts = res.data.fontStyle;
    //     }
    //   });
    // },
    personLists() {
      let params = {
        id: this.id
      };
      personLists(params).then(res => {
        if (res.code == 0) {
          this.participants = res.data.signList;
          this.unregisterlist = res.data.unSignList;
        }
      });
    },
    comHandle() {
      history.back();
    },
    changeF(font) {
      this.fonts = font;
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // padding: 6% 1s0%;
  font-size: 36px;
  .bgbody {
    // padding: 5% 0;
    position: fixed;
    top: 15%;
    left: 0;
    right: 0;
    bottom: 0;
    .center {
      width: 70%;
      height: 80%;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.1);
      padding: 3% 8%;
      // font-weight: bold;
      .header {
        text-align: center;
        font-size: 40px;
        margin-bottom: 5%;
        letter-spacing: 3px;
      }
      .registerCon {
        display: flex;
        margin-bottom: 5%;
        .radius {
          margin: 0 auto;
          border-radius: 50%;
          text-align: center;
          background: url("../assets/touming.png") no-repeat;
          background-position: center;
          font-size: 36px;
          padding: 58px;
          .registerOk {
            background-image: linear-gradient(to bottom, #1cf7e9, #2ad8ff);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }
      .registerBottomContainer {
        display: flex;
        height: 200px;
        .registerBottom {
          // width: 100%;
          flex: 1;
          overflow: hidden;
          display: flex;

          .leftButton {
            width: 3%;
            // height: 5%;
            text-align: center;
            background: radial-gradient(
              rgba(0, 0, 0, 0) 0,
              rgba(255, 255, 255, 0.4) 100%
            );
            margin-right: 29px;
            border-radius: 5px;
            font-size: 30px;
            padding: 25px 5px;
          }
          .bottomList {
            overflow: hidden;
            overflow-x: auto;
            width: 97%;
            ul {
              height: 100%;
              li {
                float: left;
                font-size: 20px;
                margin-right: 32px;
                width: 200px;
                height: 100%;
                .AstarLi {
                  height: 100%;
                  .astarText {
                    text-align: center;
                    height: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }
              }
            }
            .bottomList::-webkit-scrollbar {
              display: none;
            }
          }
        }
      }
    }
  }
  .complete {
    width: 35%;
    height: 15%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    .comButton {
      width: 234px;
      height: 80px;
      background: linear-gradient(0deg, #1bf7e9, #2ad7ff);
      border-radius: 4px;
      .comText {
        font-size: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 80px;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .bg .center .registerCon {
    font-size: 20px;
    margin-bottom: 80px;
  }
  .bg .center .registerCon .registerRight .imgBox .imgtext {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registerOk.vue